import { Section } from "@/components/sections/Section";
import type { Section as SectionType } from "@/types/global";

type HeroSection = Extract<SectionType, { type: "hero" }>;

export function Hero({ settings, data }: HeroSection) {
  const { subtitle, title, content, image, cta } = data;
  return (
    <Section settings={settings} contained={false} className="min-h-[60vh] flex items-end">
      {image && (
        <>
          <img
            src={image.url}
            alt={image.alt}
            width={image.width || undefined}
            height={image.height || undefined}
            className="absolute inset-0 h-full w-full object-cover"
            style={{ objectPosition: image.focus_point }}
            loading="eager"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-transparent" aria-hidden />
        </>
      )}
      <div className="container relative z-10 pb-16 md:pb-20">
        {subtitle && <p className="surtitre">{subtitle}</p>}
        <h1 className="heading-hero mt-2 max-w-4xl">{title}</h1>
        <span className="separateur" />
        {content && (
          <div
            className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-foreground/90"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        )}
        {cta && (
          <a
            href={cta.url}
            target={cta.target || undefined}
            rel={cta.target === "_blank" ? "noopener noreferrer" : undefined}
            className="mt-8 inline-flex items-center justify-center rounded-sm bg-gradient-fire px-7 py-3.5 text-sm font-bold uppercase text-primary-foreground shadow-fire transition-smooth hover:opacity-95"
          >
            {cta.title || "En savoir plus"}
          </a>
        )}
      </div>
    </Section>
  );
}
